import { WIDGET_TYPES } from '@/models/layoutDesigner';
import { formatTemplateWidgets, formatTileWidgets, buildPlaylistItemsMap } from '@/helpers/utils';
import { getSimpleType } from '@/mixins/simple-type';

function attachPlaylistEmbeddedChildren(item, playlistId, result) {
  if (!item.children) return;

  const itemType = getSimpleType(item.item_type);
  const templateId = item.item_url;

  if (itemType === 'template') {
    const widgets = formatTemplateWidgets(item.children);

    result.templateOnPlaylistItems[playlistId] = widgets;
    result.cacheWrites.push({
      key: `template-items-${playlistId}-undefined-${templateId}`,
      data: widgets,
    });
  } else if (itemType === 'local-template') {
    const widgets = formatTileWidgets(item.children);

    if (!result.localTemplatesItems[playlistId]) result.localTemplatesItems[playlistId] = {};
    result.localTemplatesItems[playlistId][templateId] = widgets;
    result.cacheWrites.push({
      key: `local-template-items-${playlistId}-${templateId}`,
      data: widgets,
    });
  }
}

// Walks the snapshot's already-formatted top-level layout children and derives the same
// per-assoc_id/playlist_id/template_id slices that PlaylistPlayer/TemplateViewer/TileViewer
// would otherwise fetch and format themselves, so their `if (this.widgets) return` /
// `if (!!this.slides) return` guards short-circuit and no secondary HTTP calls happen.
export function extractSnapshotStoreSlices(layoutChildren) {
  const result = {
    playlistsItems: {},
    templateItems: {},
    templateOnPlaylistItems: {},
    localTemplatesItems: {},
    cacheWrites: [],
  };

  layoutChildren.forEach((child) => {
    if (child.type === WIDGET_TYPES.PLAYLIST && child.children) {
      const playlistId = child.object.playlist_id;
      const assocId = child.assoc_id;
      const playlistItemsMap = buildPlaylistItemsMap(child.children);

      result.playlistsItems[assocId] = playlistItemsMap;
      result.cacheWrites.push({
        key: `playlist-items-${playlistId}-${assocId}`,
        data: playlistItemsMap,
      });

      Object.values(playlistItemsMap).forEach((item) =>
        attachPlaylistEmbeddedChildren(item, playlistId, result),
      );
    } else if (child.type === WIDGET_TYPES.TEMPLATE && child.children) {
      const assocId = child.assoc_id;
      const templateId = child.object.template_id;
      const widgets = formatTemplateWidgets(child.children);

      result.templateItems[assocId] = widgets;
      result.cacheWrites.push({
        key: `template-items-undefined-${assocId}-${templateId}`,
        data: widgets,
      });
    }
  });

  return result;
}
